import { IInitialFilter } from "../Interfaces";

export const initialFilter : IInitialFilter = {
    name: "",
    date: "",
    assignedTo: "",
    description: ""
}